import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLicenseProductBriefFunctionalitiesPresets = (store: StoreSchema) =>
	store.license.cachedLicense.productBrief.functionalitiesPresets